import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { CompanyQuarter, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './company-quarter.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class CompanyQuarterComponent extends RepositoryModal<CompanyQuarter> {}
